import { useQueryClient } from "@tanstack/react-query";
import { deleteOwnerId } from "../../api/owner-ids";
import { showToast } from "@/modules/common/utils";
import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

const useDeleteOwnerId = (customerUid?: string) => {
  const queryClient = useQueryClient();

  const mutation = useDomainMutation({
    mutationFn: (ownerIdUid: string) => deleteOwnerId(ownerIdUid),
    onSuccess: () => {
      showToast({
        type: ToastType.SUCCESS,
        message: "Owner ID deleted successfully",
        toastId: TOAST_IDS.DELETE_OWNER_ID_SUCCESS,
      });
      queryClient.invalidateQueries({ queryKey: ["owner-ids", customerUid] });
    },
    onError: () => {
      showToast({
        type: ToastType.ERROR,
        message: "Failed to delete owner ID",
        toastId: TOAST_IDS.DELETE_OWNER_ID_ERROR,
        options: {
          position: "bottom-left",
          autoClose: 3000,
        },
      });
    },
  });

  return {
    deleteOwnerId: mutation.mutate,
    isDeleting: mutation.isPending,
  };
};

export default useDeleteOwnerId;
